import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const downpayment = Loadable(() => import('../../containers/web/downpayment'));
export default MapTo('vcg/components/soe-home/react/downpayment')(downpayment);
